/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FinancialDataDto,
} from '../models/index';
import {
    FinancialDataDtoFromJSON,
    FinancialDataDtoToJSON,
} from '../models/index';

/**
 * ExpensesApi - interface
 * 
 * @export
 * @interface ExpensesApiInterface
 */
export interface ExpensesApiInterface {
    /**
     * Creates request options for expensesGetReportGET without sending the request
     * @throws {RequiredError}
     * @memberof ExpensesApiInterface
     */
    expensesGetReportGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApiInterface
     */
    expensesGetReportGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialDataDto>>>;

    /**
     */
    expensesGetReportGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialDataDto>>;

}

/**
 * 
 */
export class ExpensesApi extends runtime.BaseAPI implements ExpensesApiInterface {

    /**
     * Creates request options for expensesGetReportGET without sending the request
     */
    async expensesGetReportGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Expenses`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async expensesGetReportGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialDataDto>>> {
        const requestOptions = await this.expensesGetReportGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialDataDtoFromJSON));
    }

    /**
     */
    async expensesGetReportGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialDataDto>> {
        const response = await this.expensesGetReportGETRaw(initOverrides);
        return await response.value();
    }

}
